import React from 'react';

import withStyles from '@material-ui/core/styles/withStyles';

class SegmentSpacer extends React.Component{


    render(){
        const { classes } = this.props;
        return(
            <div className={classes.spacer}/>
        )
    }
}

const styles = theme => ({
    spacer: {
        width: '100%',
        height: theme.spacing(4)
    }
});

export default withStyles(styles)(SegmentSpacer);